window._ = require('lodash')

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
/* Add csrf token for axios request */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.axios.defaults.headers.post['X-CSRF-TOKEN'] = window.token
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.moment = require('moment')
window.moment.locale(window.locale)

window.$ = require('jquery')

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
window.isEnvDevelopment = process.env.NODE_ENV === 'development'
